var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarouselPrev = function SvgCarouselPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 29,
    fill: "none",
    viewBox: "0 0 18 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323338",
    fillRule: "evenodd",
    d: "m.683 15.841 1.649-1.591-1.649-1.591a2.195 2.195 0 0 0 0 3.182M5.63 14.25 16.417 3.841c.91-.879.91-2.303 0-3.182a2.39 2.39 0 0 0-3.298 0l-12.436 12 1.649 1.591-1.649 1.591 12.436 12c.911.879 2.387.879 3.298 0 .91-.879.91-2.303 0-3.182z",
    clipRule: "evenodd"
  })));
};
export default SvgCarouselPrev;